import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
// S1
import BaseMixer from "@/router/views/BaseMixer";
import VueApexChart from "vue-apexcharts";
let EcPieChart = /** @class */ (() => {
    let EcPieChart = class EcPieChart extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.pieChart = {
                chartOptions: {
                    chart: {
                        type: "pie",
                        fontFamily: '"Poppins", sans-serif',
                        animations: {
                            enabled: true,
                            easing: "easeinout",
                            speed: 800,
                            animateGradually: {
                                enabled: true,
                                delay: 150,
                            },
                            dynamicAnimation: {
                                enabled: true,
                                speed: 350,
                            },
                        },
                    },
                    labels: [],
                    colors: ["#50a5f1", "#f1b44c", "#228E68", "#556ee6", "#f46a6a", "#E83E8C", "#FF4560", "#495057", "#6F42C1", "#564AB1"],
                    legend: {
                        show: true,
                        position: "bottom",
                        horizontalAlign: "left",
                        verticalAlign: "middle",
                        floating: false,
                        fontSize: "13px",
                        offsetX: 0,
                    },
                    tooltip: {
                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                            const hours = Math.floor((series[seriesIndex] * 60) / 3600);
                            const minutes = Math.floor(((series[seriesIndex] * 60) % 3600) / 60);
                            const time = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
                            return '<div class="arrow_box">' + "<span>" + time + "</span>" + "</div>";
                        },
                    },
                    responsive: [
                        {
                            breakpoint: 600,
                            options: {
                                chart: {
                                    height: 380,
                                },
                                legend: {
                                    show: false,
                                },
                            },
                        },
                    ],
                },
                series: [],
            };
        }
        created() {
            this.pieChart.series = this.series;
            this.pieChart.chartOptions.labels = this.options;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcPieChart.prototype, "series", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcPieChart.prototype, "options", void 0);
    EcPieChart = __decorate([
        Component({
            name: "EcPieChart",
            components: {
                VueApexChart,
            },
        })
    ], EcPieChart);
    return EcPieChart;
})();
export default EcPieChart;
